import { createSelector } from 'reselect';
import { selectLocations } from '../../locations/locations.selectors';
import { selectCurrentLocationId } from '../../current-location';

export const selectLocationRingtoneIds = (locationId: string) =>
  createSelector(selectLocations, (locations) => locations[locationId]?.ringtoneIds);

export const selectCurrentLocationRingtoneIds = createSelector(
  selectLocations,
  selectCurrentLocationId,
  (locations, currentLocationId) => locations[currentLocationId]?.ringtoneIds
);
